import {
  LuBookmarkCheck,
  LuCircleCheckBig,
  LuClipboardList,
  LuGitPullRequestArrow,
  LuLandPlot,
  LuLayoutGrid,
  LuMap,
  LuTruck,
} from 'react-icons/lu'

import { routePaths } from '@/lib/core/constants/routes'

import { NavItem } from './SidebarNav.types'

/**
 * The single source of truth for top-level navigation. Consumed by both the
 * sidebar and the command palette via `useNavItems`, so the two cannot drift
 * apart — see the gating notes on `SidebarNav.utils.ts`.
 */
export const navItems: NavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    href: routePaths.home,
    Icon: LuLayoutGrid,
  },
  {
    id: 'assets',
    label: 'Assets',
    href: routePaths.assets,
    Icon: LuTruck,
  },
  {
    id: 'smart-share',
    label: 'Smart Share',
    href: routePaths.share,
    Icon: LuGitPullRequestArrow,
  },
  {
    id: 'contacts',
    label: 'Contacts',
    href: routePaths.contacts,
    Icon: LuCircleCheckBig,
  },
  {
    id: 'map-overview',
    label: 'Map Overview',
    href: routePaths.mapOverview,
    Icon: LuMap,
    blockedForSubbies: true,
  },
  {
    id: 'reports',
    label: 'Reports',
    href: routePaths.reportOverview,
    Icon: LuClipboardList,
    flag: 'featureReports',
  },
  {
    id: 'execution-board',
    label: 'Execution Board',
    href: routePaths.executionBoard,
    Icon: LuBookmarkCheck,
    flag: 'featureExecutionBoardUi',
  },
  {
    id: 'locations',
    label: 'Locations',
    href: routePaths.locations,
    Icon: LuLandPlot,
    flag: 'featureExecutionBoardUi',
  },
]
